import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CampaignOptimizationState} from './campaignOptimization.types';
import {DetailedOptimizationTableData} from 'common/src/modules/experiment/experiment.types';

const campaignOptimizationInitialState: CampaignOptimizationState = {
  optimizationPreviewIds: [],
  selectedOptimizationId: null,
  optimizations: [],
};

const campaignOptimizationSlice = createSlice({
  name: 'campaignOptimization',
  initialState: campaignOptimizationInitialState,
  reducers: {
    resetCampaignOptimization: () => campaignOptimizationInitialState,
    updateOptimizationPreviewIds: (state, action: PayloadAction<number[]>) => {
      state.optimizationPreviewIds = action.payload;
    },
    updateSelectedOptimizationId: (state, action: PayloadAction<string>) => {
      state.selectedOptimizationId = action.payload;
    },
    updateOptimizations: (state, action: PayloadAction<DetailedOptimizationTableData[]>) => {
      state.optimizations = action.payload;
    },
  },
});

const {
  resetCampaignOptimization,
  updateOptimizationPreviewIds,
  updateSelectedOptimizationId,
  updateOptimizations,
} = campaignOptimizationSlice.actions;

export {
  resetCampaignOptimization,
  updateOptimizationPreviewIds,
  updateSelectedOptimizationId,
  updateOptimizations,
};

export default campaignOptimizationSlice.reducer;
